import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'qbank-structure-details';

const ELEMENTS = define({
  STATUS_TAG: ['status', 'tag'],
  COURSE_ID_TEXT: ['course-id', 'text'],
  TYPE_TAG: ['type', 'tag'],
  NAVIGATION_TAB: ['navigation', 'tab'],
  LEVEL_ITEM_ROW: ['level-item', 'row'],
  SET_NON_INFO_MENU: ['set-non-info', 'menu'],
  SAVE_BUTTON: ['save', 'button'],
  HEADER_MENU: ['header', 'menu'],
  EDIT_FORM: ['edit', 'form'],
  PUBLISH_CONFIRMATION_MODAL_CONFIRM_BUTTON: ['publish-confirmation-modal', 'confirm', 'button'],
});

export const QBS_DETAILS_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
